import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { SliderProps } from './models';

const height = '36px';
const thumbHeight = 26;
const trackHeight = '16px';

// colours
const upperColor = '#E7E9EE';
const lowerColor = '#E7E9EE';
const thumbColor = '#3156DB';
const upperBackground = `linear-gradient(to bottom, ${upperColor}, ${upperColor}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;
const lowerBackground = `linear-gradient(to bottom, ${lowerColor}, ${lowerColor}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;

const disabledStyle = css(
  ({ theme }) => css`
    pointer-events: none;
    cursor: not-allowed;

    &::-webkit-slider-thumb {
      background-color: ${theme.colors.disabledText};
      box-shadow: 0px 4px 3px ${theme.colors.disabledButton};
    }

    &::-moz-range-thumb {
      background-color: ${theme.colors.disabledText};
      background: ${theme.colors.disabledText};
    }

    &::-ms-thumb {
      background-color: ${theme.colors.disabledText};
      background: ${theme.colors.disabledText};
      box-shadow: none;
    }
  `
);

const StyledSlider = styled.input`
  overflow: hidden;
  display: block;
  appearance: none;
  max-width: 700px;
  width: 100%;
  margin: 0;
  height: ${height};
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    border-radius: 30px;
    height: ${height};
    background: ${lowerBackground};
  }

  &::-webkit-slider-thumb {
    background-color: ${thumbColor};
    position: relative;
    appearance: none;
    height: ${thumbHeight}px;
    width: ${thumbHeight}px;
    border-radius: 100%;
    border: 0;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: 0px 4px 7px rgba(49, 86, 219, 0.29);
  }

  &::-moz-range-track,
  &::-moz-range-progress {
    width: 100%;
    height: ${height};
    background: ${upperBackground};
  }

  &::-moz-range-progress {
    background: ${lowerBackground};
  }

  &::-moz-range-thumb {
    background-color: ${thumbColor};
    margin: 0;
    height: ${thumbHeight};
    width: ${thumbHeight};
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
  }

  &::-ms-track {
    width: 100%;
    height: ${height};
    border: 0;
    /* color needed to hide track marks */
    color: transparent;
    background: transparent;
  }

  &::-ms-fill-lower {
    background: ${lowerBackground};
  }

  &::-ms-fill-upper {
    background: ${upperBackground};
  }

  &::-ms-thumb {
    background-color: ${thumbColor};
    height: ${thumbHeight};
    width: ${thumbHeight};
    background: ${thumbColor};
    border-radius: 100%;
    border: 0;
    transition: background-color 150ms;
    /* IE Edge thinks it can support -webkit prefixes */
    top: 0;
    margin: 0;
    box-shadow: none;
  }

  ${({ disabled }) => disabled && disabledStyle};
` as React.FC<SliderProps>;

export const Slider: FC<SliderProps> = (props) => {
  const value = props.value?.replace('$ ', '');

  return <StyledSlider type="range" {...{ ...props, value }} />;
};
